import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-edit-zone',
  templateUrl: './edit-zone.component.html',
  styleUrls: ['./edit-zone.component.scss']
})
export class EditZoneComponent implements OnInit {

  @Input() edit: boolean = false;
  @Input() locationData;

  public zoneForm: FormGroup;
  public nodalForm: FormGroup;
  public showNodalModal: boolean = false;
  public editLocation:boolean=true;
  

  public formSubmit: boolean = false;
  public nodalFormSubmit: boolean = false;

  public nodalPoints: any[] = [];
  public nodalLocation: any = {};
  public editingNodalIndex: number | null = null;

  public fieldOptions = {
    branch: [],
    transitMode: [
      { value: 'pickup', name: 'Pickup' },
      { value: 'drop', name: 'Drop' }
    ]
  };

  public branchInformation: any[] = [];
  public nodalID: string;
  public updateValues=[];

  // snapshot of original data to detect changes
  private originalZoneSnapshot: any = null;

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute,
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.nodalID = params.params.zoneID;
    });
  }

  ngOnInit(): void {
    this.loadZoneForm();
    this.loadNodalForm();
    this.getBranchList();
    if (this.nodalID) {
      this.loadZoneDetails();
    }
  }

  loadZoneForm() {
    this.zoneForm = new FormGroup({
      zoneName: new FormControl('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),
      //transitMode: new FormControl('', [Validators.required])
    });
  }

  loadNodalForm() {
    this.nodalForm = new FormGroup({
      area: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required])
    });
  }

  /* Branch list */
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  addBranchOptions() {
    this.fieldOptions.branch = [];
    if (this.branchInformation && this.branchInformation.length > 0) {
      this.branchInformation.filter((e) => {
        if (!(e?.isNodal || e?.isNodalBranch || e?.nodalBranch)) {
          return;
        }
        const option = { name: e.branchName, value: e.branchID };
        this.fieldOptions.branch.push(option);
      });
    }
  }


  loadZoneDetails() {
    const obj = { nodalID: this.nodalID };
    this.api.transportManagerZoneList(obj).then((res: any) => {
      if (res && res.status === 'success') {
        let zone: any = null;

        if (Array.isArray(res.data)) {
          zone = res.data.find((z: any) => (z.nodalID || z.zoneID) === this.nodalID) || res.data[0];
        } else {
          zone = res.data;
        }

        if (zone) {
          this.patchZoneForm(zone);
        }
      }
    }).catch((err) => {
      console.log(err);
      this.swal.swalFunction('error', 'error', 'Failed to load zone details.', 3000);
    });
  }

  async patchZoneForm(zone: any) {
    const zoneBranch = zone.branch || zone.branchID;
    const zoneNodalPoints = Array.isArray(zone.nodalPoints) ? zone.nodalPoints : zone.nodalPoint;

    this.zoneForm.patchValue({
      zoneName: zone.zoneName,
      branch: zoneBranch,
      //transitMode: (zone.transitMode || '').toLowerCase()
    });

    // Base nodalPoints from API data
    this.nodalPoints = Array.isArray(zoneNodalPoints)
      ? zoneNodalPoints.map((p: any) => ({
          area: p.name,
          location: {
            lat: p.location?.lat,
            lng: p.location?.lng,
            // keep existing name if available; we will try to fill it otherwise
            name: p.location?.name || ''
          }
        }))
      : [];

    // For nodal points with lat/lng but no name, reverse-geocode to get address
    for (let i = 0; i < this.nodalPoints.length; i++) {
      const loc = this.nodalPoints[i].location;
      if (loc && loc.lat != null && loc.lng != null && !loc.name) {
        const obj = {
          params: {
            latlng: `${loc.lat},${loc.lng}`
          }
        };
        try {
          const res: any = await this.api.transportManagerGoogleMapGeocoder(obj);
          if (res && res.status === 'success' && res.data) {
            try {
              const parsed = JSON.parse(res.data);
              const name = parsed?.results?.[0]?.formatted_address || '';
              if (name) {
                this.nodalPoints[i].location.name = name;
              }
            } catch (e) {
              console.log('Error parsing geocoder response:', e);
            }
          }
        } catch (err) {
          console.log('Geocoder error for nodal point:', err);
        }
      }
    }

    // After geocoding is done, take an immutable snapshot for change detection & reset
    this.originalZoneSnapshot = this.buildZoneSnapshot();
  }

  /* Nodal point helpers */
  getNodalLocation(obj: any) {
    this.nodalLocation = { ...obj };
    this.fieldChange(this.nodalLocation,'location','location'); 
  }

   /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='text' || type=='textarea'){
      this.updateField(field,e.target.value);
    }
    /* if(type=='date' || type=='dropdown'){
      this.updateField(field,e.value);
    } */
    if(type=='location'){
      this.updateField(field,e);
    }
    if(type=='number'){
      this.updateField(field, +e.target.value);
    }
    if(type=='checkbox'){
      this.updateField(field,e.checked);
    }
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
  }

  openNodalModal() {
    this.showNodalModal = true;
  }
  resetNodalForm() {
    this.nodalForm.reset();
    this.nodalLocation = {};
    this.nodalFormSubmit = false;
    this.editingNodalIndex = null;
  }

  // Restore nodalPoints order and values back to the original snapshot
  resetNodalOrder() {
    if (!this.originalZoneSnapshot || !Array.isArray(this.originalZoneSnapshot.nodalPoints)) {
      return;
    }
    this.nodalPoints = this.originalZoneSnapshot.nodalPoints.map((p: any) => ({
      area: p.area,
      location: {
        lat: p.location?.lat,
        lng: p.location?.lng,
        name: p.location?.name || ''
      }
    }));
  }

  addNodalPoint() {
    this.nodalFormSubmit = true;
    if (this.nodalForm.valid) {
      const value = this.nodalForm.value;

      // ensure nodalLocation exists and update its name from the control value
      this.nodalLocation = {
        ...(this.nodalLocation || {}),
        name: value.location
      };

      const node = {
        area: value.area,
        location: { ...this.nodalLocation }
      };

      if (this.editingNodalIndex !== null && this.editingNodalIndex >= 0) {
        this.nodalPoints[this.editingNodalIndex] = node;
      } else {
        this.nodalPoints.push(node);
      }

      this.resetNodalForm();
      this.closeNodalModal();
    }
  }

  
  dropNodalPoint(event: CdkDragDrop<any[]>) {
    if (!event || event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.nodalPoints, event.previousIndex, event.currentIndex);
  }

  removeNodalPoint(index: number) {
    this.nodalPoints.splice(index, 1);
  }

  editNodalPoint(index: number) {
    const point = this.nodalPoints[index];
    if (!point) { return; }

    this.editingNodalIndex = index;
    // For the form control, show the human-readable name string
    this.nodalForm.patchValue({
      area: point.area,
      location: point.location?.name || ''
    });
    // Keep full object for saving (lat, lng, name)
    this.nodalLocation = { ...point.location };
    this.nodalFormSubmit = false;
    this.openNodalModal();
  }

  closeNodalModal() {
    this.showNodalModal = false;
  }

  /* checking error in main form fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.zoneForm && this.zoneForm.controls[controlName].hasError(errorName);
  }

  /* checking error in nodal form fields*/
  public checkNodalError = (controlName: string, errorName: string) => {
    return this.nodalFormSubmit && this.nodalForm && this.nodalForm.controls[controlName].hasError(errorName);
  }

  /* Cancel Edit Zone */
  cancel() {
    this.router.navigate(['/organization/transport-manager/information/orgInfo/zone/view-zone']);
  }

  /* Submit Zone Update */
  onSubmit() {
    this.formSubmit = true;

    if (!this.zoneForm.valid) {
      return;
    }

    if (!this.nodalPoints || this.nodalPoints.length === 0) {
      this.swal.swalFunction('warning', 'Validation', 'Please add at least one nodal point.', 3000);
      return;
    }

    if (!this.nodalID) {
      this.swal.swalFunction('error', 'Error', 'Nodal ID not found.', 3000);
      return;
    }

    // Prevent update when there are no changes compared to original snapshot
    const currentSnapshot = this.buildZoneSnapshot();
    if (this.originalZoneSnapshot && JSON.stringify(currentSnapshot) === JSON.stringify(this.originalZoneSnapshot)) {
      this.swal.swalFunction('warning', 'No Changes', 'No changes detected to update.', 3000);
      return;
    }

    const formValue = this.zoneForm.value;

    const payload: any = {
      nodalID: this.nodalID,
      zoneName: formValue.zoneName,
      branch: formValue.branch,
      //transitMode: (formValue.transitMode || '').toLowerCase(),
      nodalPoints: this.nodalPoints.map((point, index) => ({
        name: point.area || (point.location && point.location.name) || '',
        location: {
          lat: point.location?.lat,
          lng: point.location?.lng,
          name: point.location?.name || point.area || ''
        },
        sequenceNo: index + 1
      }))
    };

    this.api.transportManagerZoneUpdate(payload).then((res: any) => {
      if (res && res.status === 'success') {
        this.swal.swalFunction('success', res.status, res.message || 'Zone updated successfully.', 2000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/zone/view-zone']);
      } else {
        this.swal.swalFunction('error', res?.status || 'error', res?.message || 'Failed to update zone.', 3000);
      }
    }).catch((err) => {
      console.log(err);
      this.swal.swalFunction('error', 'error', 'Something went wrong while updating zone.', 3000);
    });
  }

  // Build a lightweight snapshot of current form + nodalPoints for change detection
  private buildZoneSnapshot() {
    const formValue = this.zoneForm ? this.zoneForm.value : {};
    return {
      zoneName: formValue.zoneName,
      branch: formValue.branch,
      //transitMode: (formValue.transitMode || '').toLowerCase(),
      nodalPoints: this.nodalPoints.map((p: any) => ({
        area: p.area,
        location: {
          lat: p.location?.lat,
          lng: p.location?.lng,
          name: p.location?.name || ''
        }
      }))
    };
  }

}
